export const language_en = {
}

export const var_language_en = {
}

export const err_language_en = {
}
